__turbopack_context__.v({
  "back": "LoginView-module__vTh7Hq__back",
  "brand": "LoginView-module__vTh7Hq__brand",
  "brandName": "LoginView-module__vTh7Hq__brandName",
  "card": "LoginView-module__vTh7Hq__card",
  "error": "LoginView-module__vTh7Hq__error",
  "field": "LoginView-module__vTh7Hq__field",
  "fields": "LoginView-module__vTh7Hq__fields",
  "forgotRow": "LoginView-module__vTh7Hq__forgotRow",
  "headline": "LoginView-module__vTh7Hq__headline",
  "root": "LoginView-module__vTh7Hq__root",
  "sent": "LoginView-module__vTh7Hq__sent",
  "submit": "LoginView-module__vTh7Hq__submit",
  "switch": "LoginView-module__vTh7Hq__switch",
  "tagline": "LoginView-module__vTh7Hq__tagline",
});
